import useFeature from "@casino/legacy/client/hooks/feature/useFeature";
import useTranslation from "@casino/legacy/client/hooks/i18n/useTranslation";
import Stack from "@casino/legacy/client/shared/Stack";

const ProtectedByRecaptcha: FC = () => {
  const { recaptchaMessage, hideMessage } = useProtectedByRecaptcha();
  if (hideMessage) {
    return null;
  }

  return (
    <Stack space="small" alignContent="end">
      <p
        className="text-xs text-muted-foreground"
        dangerouslySetInnerHTML={{ __html: recaptchaMessage }}
      />
    </Stack>
  );
};

const useProtectedByRecaptcha = () => {
  const recaptchaMessage = useTranslation("general.protected_by_recaptcha");
  const isRecaptchaV3Enabled = useFeature("isRecaptchaV3Enabled");
  return { recaptchaMessage, hideMessage: !isRecaptchaV3Enabled };
};

export default ProtectedByRecaptcha;
